import { staticLoader } from '@/lib/helpers/imageLoader'
import styles from './BlogCalculatorCta.module.css'
import blogCalCta from '../../../public/assets/images/blogCalCta.svg'
import Image from 'next/image'
export function BlogCalculatorCta() {
    return  <div className={`${styles.blogCalculatorCta} ctaForm`}>
            <p className={styles.head}>Know Your Modular Kitchen Price in a Click!</p>
            <button className={`btn btnPrimery font12`} >Calculate Now</button>
            <figure className={`${styles.bgCta} ctaForm`}>
                <Image
                    src={blogCalCta}
                    height={200}
                    width={280}
                    alt="blogUser"
                    loader={staticLoader}
                    className="img-responsive"
                />
            </figure>
        </div>
}